import { semanticColors } from "~/common/colors/colors";

type ColorSet = {
    dark: string;
    standard?: string;
    light: string;
    background: string;
    label: string;
};

export const itemColorSets: Dictionary<ColorSet> = {
    Project: {
        background: semanticColors.colorCoding.blue.background.thin,
        dark: semanticColors.colorCoding.blue.border.medium,
        light: semanticColors.colorCoding.blue.background.light,
        label: semanticColors.colorCoding.blue.text.onMedium,
    },
    ProjectArchive: {
        background: semanticColors.colorCoding.blue.background.thin,
        dark: semanticColors.colorCoding.blue.border.medium,
        light: semanticColors.colorCoding.blue.background.light,
        label: semanticColors.colorCoding.blue.text.onMedium,
    },
    Issue: {
        background: semanticColors.colorCoding.purple.background.thin,
        dark: semanticColors.colorCoding.purple.border.medium,
        light: semanticColors.colorCoding.purple.background.light,
        label: semanticColors.colorCoding.purple.text.onMedium,
    },
    Request: {
        background: semanticColors.colorCoding.lime.background.thin,
        dark: semanticColors.colorCoding.lime.border.medium,
        light: semanticColors.colorCoding.lime.background.light,
        label: semanticColors.colorCoding.lime.text.onMedium,
    },
    Task: {
        background: semanticColors.colorCoding.teal.background.thin,
        dark: semanticColors.colorCoding.teal.border.medium,
        light: semanticColors.colorCoding.teal.background.light,
        label: semanticColors.colorCoding.teal.text.onMedium,
    },
    Milestone: {
        background: semanticColors.colorCoding.amber.background.thin,
        dark: semanticColors.colorCoding.amber.border.medium,
        light: semanticColors.colorCoding.amber.background.light,
        label: semanticColors.colorCoding.amber.text.onMedium,
    },
    CriticalPath: {
        background: semanticColors.colorCoding.red.background.thin,
        dark: semanticColors.colorCoding.red.border.medium,
        light: semanticColors.colorCoding.red.background.light,
        label: semanticColors.colorCoding.red.text.onMedium,
    },
};

export const itemColors = {
    Project: {
        background: semanticColors.colorCoding.blue.background.light,
        textColor: semanticColors.colorCoding.blue.icon.onLight,
    },
    ProjectArchive: {
        background: semanticColors.colorCoding.blueGrey.background.light,
        textColor: semanticColors.colorCoding.blueGrey.icon.onLight,
    },
    JobRole: {
        background: semanticColors.colorCoding.blue.background.light,
        textColor: semanticColors.colorCoding.blue.icon.onLight,
    },
    Issue: {
        background: semanticColors.colorCoding.purple.background.light,
        textColor: semanticColors.colorCoding.purple.icon.onLight,
    },
    Risk: {
        background: semanticColors.colorCoding.red.background.light,
        textColor: semanticColors.colorCoding.red.icon.onLight,
    },
    Request: {
        background: semanticColors.colorCoding.lime.background.light,
        textColor: semanticColors.colorCoding.lime.icon.onMedium,
    },
    Task: {
        background: semanticColors.colorCoding.teal.background.light,
        textColor: semanticColors.colorCoding.teal.icon.onLight,
    },
    Milestone: {
        background: semanticColors.colorCoding.amber.background.light,
        textColor: semanticColors.colorCoding.amber.icon.onLight,
    },
    Portfolio: {
        background: semanticColors.colorCoding.green.background.light,
        textColor: semanticColors.colorCoding.green.icon.onLight,
    },
    WithoutPortfolio: {
        background: semanticColors.colorCoding.blueGrey.background.light,
        textColor: semanticColors.colorCoding.blueGrey.icon.onLight,
    },
    Customer: {
        background: semanticColors.colorCoding.orange.background.light,
        textColor: semanticColors.colorCoding.orange.icon.onLight,
    },
    OtherProjects: {
        background: semanticColors.colorCoding.blueGrey.background.bold,
        textColor: semanticColors.colorCoding.blueGrey.icon.onBold,
    },
} as const;
